import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './providers/AuthProvider';
import AnimatedRoutes from './components/animations/AnimatedRoutes';
import LuckyOrangeTracking from './components/tracking/LuckyOrangeTracking';
import GoogleAnalyticsTracking from './components/tracking/GoogleAnalyticsTracking';
import CookiePreferences from './components/privacy/CookiePreferences';

import './styles/fonts.css';

const queryClient = new QueryClient();

function App() {
    return (
        <Router>
            <GoogleAnalyticsTracking />
            <LuckyOrangeTracking />
            <CookiePreferences />
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <AnimatedRoutes />
                </AuthProvider>
            </QueryClientProvider>
        </Router>
    );
}

export default App;
